import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { organizationApi } from '../../../services/api';
import { useAlert } from '../../../contexts/AlertContext';

const EmployeeEngagementModelSelector = ({
  value = '',
  onChange,
  label = 'Engagement Model',
  required = false,
  disabled = false,
  fullWidth = true,
  size = 'medium',
  ...props
}) => {
  const [engagementModels, setEngagementModels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchEngagementModels = async () => {
      try {
        setIsLoading(true);
        const data = await organizationApi.getEmployeeEngagementModels();
        setEngagementModels(data);
      } catch (error) {
        showAlert('Failed to load engagement models', 'error', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEngagementModels();
  }, [showAlert]);

  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      disabled={disabled || isLoading}
      size={size}
      {...props}
    >
      <InputLabel id="employee-engagement-model-selector-label">{label}</InputLabel>
      <Select
        labelId="employee-engagement-model-selector-label"
        value={value}
        onChange={handleChange}
        label={label}
        endAdornment={isLoading ? <CircularProgress size={20} sx={{ mr: 2 }} /> : null}
      >
        <MenuItem value=""><em>None</em></MenuItem>
        {engagementModels.map((model) => (
          <MenuItem key={model.id} value={model.id}>
            {model.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EmployeeEngagementModelSelector;
